import { Component } from "react";
import type React from "react";
import { Box, Button, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { isChunkError } from "../utils/lazyWithRetry";
import { reloadPage } from "../utils/reloadPage";

interface ChunkErrorBoundaryState {
  error: Error | null;
}

export class ChunkErrorBoundary extends Component<
  { children: React.ReactNode },
  ChunkErrorBoundaryState
> {
  state: ChunkErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ChunkErrorBoundaryState {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      if (!isChunkError(error)) {
        throw error; // re-throw non-chunk errors to parent (Datadog) boundary
      }
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="calc(100vh - 80px)"
        >
          <Box
            width={360}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            <Typography
              textAlign="center"
              sx={{
                color: "var(--Blue-Navy, #153862)",
                fontFamily: "Inter",
                fontSize: "19px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "150%",
              }}
            >
              A new version is available. Tap below to reload the page.
            </Typography>
            <Button
              onClick={() => reloadPage()}
              endIcon={
                <CachedIcon sx={{ width: 16, height: 16, fill: "#FFF" }} />
              }
              sx={{
                padding: "12px 16px",
                alignItems: "center",
                // gap: '8px',
                borderRadius: "8px",
                background: "var(--Blue-Water, #009ECF)",
                color: "var(--White, #FFF)",
                fontFamily: "Inter",
                fontSize: "13px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                "&:hover": {
                  background: "var(--Blue-Water, #009ECF)",
                },
              }}
            >
              Reload Page
            </Button>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}
